/**
 * @author       joseph.murphy@zumper.com (murph)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  this file will be deleted when DLC messaging is ported to BE
 */

import { deleteUndefineds } from '@zcode-ui/map'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { Listable, Property } from '@zcode/state-type'
import { getCommonProps } from '../../modules/mixpanel/helpers/getCommonProps'
import type { PageName } from '../../modules/mixpanel/helpers/types'
import type { Dispatch, GetState } from '../../modules/types'

interface Props {
  entity: Listable | Property
  origin: string
  pageName?: PageName | string
}

export const trackSendMessageDlc =
  ({ entity, origin, pageName }: Props) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()

    const getGroupId = () => {
      if (entity.isBuilding) {
        return -1 * entity.buildingId
      }
      if (entity.groupId) {
        return entity.groupId
      }
      if (entity.listingId) {
        return entity.listingId
      }
    }

    const payload = {
      ...getCommonProps({
        state,
        pageName,
        entity,
        event: EVENT_NAMES.SEND_MESSAGE,
      }),
      [PROP_NAMES.ORIGIN]: origin,
      'is DLC': true,
      'DLC Origin Property': getGroupId(),
    }
    track({ event: EVENT_NAMES.SEND_MESSAGE, payload: deleteUndefineds(payload) })
    if (entity.feedName === 'listhub' && entity.providerId) {
      window.listhubTrack?.('AGENT_EMAIL_SENT', entity.providerId)
    }
  }
